// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Wh0l","content":"styles_content__14VJd","row":"styles_row__1ohI8","footer":"styles_footer__2yPNe","phraseLength":"styles_phraseLength__3KkgX"};